import InputCustom from '../../../../atoms/input/InputCustom'
import TextArea from '../../../../atoms/textarea/TextArea'
import { Grid } from '@mui/material'
import { useState } from 'react'
import styles from '../index.module.scss'

const CulturalModal = () => {
	const [culturalData, setCulturalData] = useState({})
	return (
		<>
			<div className={styles.header}>
				<h3>Cultural Requirements</h3>
			</div>

			<div className={`${styles.formWrp} ${styles.culturalForm}`}>
				<Grid container spacing={1.5}>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="culturalRequirements"
								className={styles.label}
							>
								Cultural/Religious Requirements
							</label>
							<TextArea
								placeholder="Describe any cultural or religious requirements"
								value={culturalData.culturalRequirements}
								onChange={(e) =>
									setCulturalData({
										...culturalData,
										culturalRequirements: e.target.value,
									})
								}
							/>
						</div>
					</Grid>

					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="officiantAvailability"
								className={styles.label}
							>
								Officiant Availability
							</label>
							<InputCustom
								type="text"
								name="officiantAvailability"
								id="officiantAvailability"
								placeholder="Time window when officiant is available"
								value={culturalData.officiantAvailability}
								onChange={(e) =>
									setCulturalData({
										...culturalData,
										officiantAvailability: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="auspiciousHours"
								className={styles.label}
							>
								Auspicious Hours
							</label>
							<InputCustom
								type="text"
								name="auspiciousHours"
								id="auspiciousHours"
								placeholder="Any specific auspicious hours to consider"
								value={culturalData.auspiciousHours}
								onChange={(e) =>
									setCulturalData({
										...culturalData,
										auspiciousHours: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="prayerBreaks"
								className={styles.label}
							>
								Prayer Breaks
							</label>
							<TextArea
								placeholder="Details about any prayer breaks needed"
								value={culturalData.prayerBreaks}
								onChange={(e) =>
									setCulturalData({
										...culturalData,
										prayerBreaks: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default CulturalModal
